import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import io from "socket.io-client";

const PaywayDeeplink = () => {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        if (location.state && location.state.url) {
            setTimeout(() => {
                window.location.href = location.state.url;
            }, 500);
        }

        if (location.state && location.state.checkout_url) {
            setTimeout(() => {
                window.location.href = location.state.checkout_url;
            }, 1000);
        }

        if (location.state && location.state.transactionId) {
            const socket = io({ transports: ['websocket'], auth: { transactionId: location.state.transactionId } });
            socket.on("duitnowPayment", (transactionId) => {
                history.push("/thankyou");
            });

            return () => {
                socket.disconnect();
            };
        }

    }, []);

    return (
        <div id="setting-page" className="user-faq">
            <div id="setting-main">
                <div id="user-header">
                    <h5><i onClick={e => history.push("/")} className="bi bi-chevron-left me-3"></i> <strong>{t("KHQR")}</strong></h5>
                </div>

                <div id="user-body">
                    <div className="pt-3 pb-3">
                        {
                            location.state?.checkout_url ? (
                                <iframe
                                    src={location.state?.checkout_url}
                                    title="Payment Checkout"
                                    style={{ width: '100%', height: '600px', border: 'none' }}
                                    allowFullScreen
                                />
                            ) : null
                        }
                        <div className="text-center">
                            {
                                location.state?.url ? (
                                    <button
                                        type="button"
                                        className="btn btn-primary mt-3"
                                        onClick={() => window.location.href = location.state.url}
                                    >
                                        Open ABA Bank App now
                                    </button>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaywayDeeplink;